// extracted by mini-css-extract-plugin
export default {"innerCustomTab":"InnerTabs_innerCustomTab__0TcAa"};